import React, { useState } from 'react';
import './App.css';

const API = 'https://msbgmzfkef.execute-api.us-east-1.amazonaws.com';

const VERDICT_EMOJI = {
  'BLOCKBUSTER': '🌟💥', 'HIT': '🎬🔥', 'AVERAGE': '🎬',
  'FLOP': '⚠️', 'DISASTER': '❌', 'BANNED': '🚫'
};

const VERDICT_CLASS = {
  'BLOCKBUSTER': 'blockbuster', 'HIT': 'hit', 'AVERAGE': 'average',
  'FLOP': 'flop', 'DISASTER': 'disaster', 'BANNED': 'banned'
};

const tc = s => s.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
const ACTORS = ['DEEPIKA','ANIL KAPOOR','ALIA BHATT','SALMAN KHAN','SHAHRUKH','RANVEER SINGH','RANBIR KAPOOR','AJAY DEVGAN','AKSHAY KUMAR','AAMIR KHAN','HRITHIK','KATRINA','KAREENA','AMITABH','GOVINDA','SAIF','KANGANA','ANUSHKA','PREITY','KRITI','PRIYANKA','RAJKUMAR','AISHWARYA','KARTIK','RANI','MADHURI','SHAHID','AYUSHMANN','IRRFAN','HEMA','ABHISHEK','FARHAN','ARJUN','TIGER','YAMI','SANJAY','BHUMI','PANKAJ','VARUN','BOMAN','DIMPLE','PARINEETI','RAVEENA','NASEER','MADHAVAN','NAWAZ','SUNNY','TAAPSEE','KARISMA','JACKIE','SONAKSHI','RISHI','KIARA','SARA','SID','JOHN','SONAM','EMRAAN','ADITYA','SHRADDHA','TABU','SUSHANT','VIDYA','JUHI','JANHVI','VICKY','ANANYA','AMRISH','SRIDEVI','PARESH'].map(tc);
const PLOTS = ['POLITICAL DRAMA','PATRIOTISM','REVENGE','COURTROOM DRAMA','WOMAN LED','SMALL TOWN DREAMS','MARRIAGE TROUBLE','HISTORICAL','BIOGRAPHY','ACTION','GANGSTER','KIDNAPPING','SCIENCE FICTION','SOCIAL ISSUE','ROAD TRIP','SUSPENSE','CHRONIC ILLNESS','LOVE TRIANGLE','HEARTBREAK','SUPER HERO','DOUBLE ROLE','RICH VS POOR','MURDER','FRIENDSHIP','TEACHER - STUDENT','FAMILY DRAMA','SPY','HORROR','SPORTS','ROMANCE','WAR','COMEDY'].map(tc);
const SCENES = ['AIRPORT','BAR','BIG HOUSE','BEACH','BOAT','BRIDGE','COURTROOM','DESERT','FORT','FOREIGN COUNTRY','GOVERNMENT OFFICE','GYM','HOTEL','HOSPITAL','JAIL','LABORATORY','LIBRARY','METRO CITY','MOVIE THEATRE','MOUNTAINS','MILITARY BASE','OFFICE','PARK','POLICE STATION','RELIGIOUS SITE','RAILWAY STATION','RIVERS & LAKE','RESTAURANT','SCHOOL/COLLEGE','STADIUM','VILLAGE','WEDDING VENUE'].map(tc);

function AutoInput({ label, placeholder, value, onChange, options }) {
  const [show, setShow] = useState(false);
  const filtered = value ? options.filter(o => o.toLowerCase().includes(value.toLowerCase())) : options;
  return (
    <div className="field autocomplete">
      <label>{label}</label>
      <input placeholder={placeholder} value={value} onChange={e => { onChange(e.target.value); setShow(true); }}
        onFocus={() => setShow(true)} onBlur={() => setTimeout(() => setShow(false), 150)} />
      {show && filtered.length > 0 && value !== filtered[0] && (
        <div className="ac-dropdown">
          {filtered.slice(0, 6).map(o => (
            <div key={o} className="ac-item" onMouseDown={() => { onChange(o); setShow(false); }}>{o}</div>
          ))}
        </div>
      )}
    </div>
  );
}

function MovieInput({ value, onChange }) {
  const [suggestions, setSuggestions] = useState([]);
  const [show, setShow] = useState(false);
  const timerRef = React.useRef();

  const onType = (v) => {
    onChange(v);
    clearTimeout(timerRef.current);
    if (v.length < 2) { setSuggestions([]); return; }
    timerRef.current = setTimeout(async () => {
      try {
        const res = await fetch(`${API}/search?q=${encodeURIComponent(v)}`);
        const data = await res.json();
        setSuggestions(data);
        setShow(true);
      } catch (e) { setSuggestions([]); }
    }, 300);
  };

  return (
    <div className="field autocomplete">
      <label>🎥 Movie</label>
      <input placeholder="e.g. Dilwale Dulhania Le Jayenge" value={value} onChange={e => onType(e.target.value)}
        onFocus={() => suggestions.length && setShow(true)} onBlur={() => setTimeout(() => setShow(false), 150)} />
      {show && suggestions.length > 0 && (
        <div className="ac-dropdown">
          {suggestions.map((s, i) => (
            <div key={i} className="ac-item" onMouseDown={() => { onChange(s.title); setShow(false); }}>{s.label || s.title}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function App() {
  const [form, setForm] = useState({ actor: '', plot: '', scene: '', movie: '' });
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [review, setReview] = useState('');
  const [showReview, setShowReview] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.actor || !form.plot || !form.scene || !form.movie) return;
    setLoading(true); setError(''); setResult(null); setShowReview(false); setReview('');
    try {
      const res = await fetch(API, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (data.error) throw new Error(data.error);
      setResult(data);
    } catch (err) { setError('Something went wrong. Try again!'); }
    setLoading(false);
  };

  const challenge = async () => {
    if (!review.trim()) return;
    setLoading(true); setError('');
    try {
      const res = await fetch(API, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, review })
      });
      const data = await res.json();
      if (data.error) throw new Error(data.error);
      setResult(data); setShowReview(false);
    } catch (err) { setError('Something went wrong. Try again!'); }
    setLoading(false);
  };

  const reset = () => { setResult(null); setForm({ actor: '', plot: '', scene: '', movie: '' }); setReview(''); setShowReview(false); };

  return (
    <div className="app">
      <div className="container">
        <h1 className="title">🎬 Bollywood Rummy Review</h1>
        <p className="subtitle">The AI-powered judge for <a href="https://amzn.to/4mL86LN" target="_blank" rel="noopener noreferrer" className="rummy-link">Bollywood Rummy</a> players — settling disputes, fair and square!</p>
        <a href="https://amzn.to/4mL86LN" target="_blank" rel="noopener noreferrer" className="amazon-btn">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M13.958 10.09c0 1.232.029 2.256-.591 3.351-.502.891-1.301 1.438-2.186 1.438-1.214 0-1.922-.924-1.922-2.292 0-2.692 2.415-3.182 4.7-3.182v.685zm3.186 7.705a.66.66 0 01-.753.077c-1.06-.878-1.25-1.284-1.828-2.12-1.748 1.784-2.986 2.317-5.251 2.317-2.681 0-4.768-1.655-4.768-4.967 0-2.585 1.401-4.344 3.392-5.205 1.726-.762 4.138-.897 5.983-1.107v-.413c0-.762.058-1.663-.389-2.321-.388-.59-1.137-.833-1.797-.833-1.22 0-2.31.626-2.576 1.924a.545.545 0 01-.467.472l-2.606-.28c-.22-.05-.465-.228-.402-.567C6.296 1.87 9.293.5 12.009.5c1.38 0 3.182.367 4.27 1.413 1.38 1.284 1.248 2.997 1.248 4.862v4.405c0 1.324.549 1.904 1.065 2.618.182.254.222.559-.009.748-.577.481-1.603 1.378-2.166 1.879l-.273-.63zM21.83 18.45c-1.996 1.478-4.893 2.265-7.387 2.265-3.498 0-6.648-1.293-9.031-3.448-.187-.17-.02-.401.205-.27 2.573 1.496 5.752 2.397 9.04 2.397 2.216 0 4.653-.46 6.895-1.413.338-.145.621.222.278.469zM22.994 17.156c-.256-.327-1.693-.155-2.34-.078-.196.024-.227-.148-.05-.272 1.146-.806 3.024-.573 3.244-.303.222.274-.058 2.17-1.132 3.074-.165.14-.322.065-.249-.12.242-.6.784-1.975.527-2.301z"/></svg>
          Buy Bollywood Rummy on Amazon
        </a>

        {!result ? (
          <form onSubmit={submit} className="form">
            <AutoInput label="🎭 Actor" placeholder="e.g. Shah Rukh Khan" value={form.actor} onChange={v => setForm({ ...form, actor: v })} options={ACTORS} />
            <AutoInput label="📖 Plot Theme" placeholder="e.g. Romance, Revenge" value={form.plot} onChange={v => setForm({ ...form, plot: v })} options={PLOTS} />
            <AutoInput label="🎬 Scene Setting" placeholder="e.g. College, Hospital" value={form.scene} onChange={v => setForm({ ...form, scene: v })} options={SCENES} />
            <MovieInput value={form.movie} onChange={v => setForm({ ...form, movie: v })} />
            <button type="submit" className="btn" disabled={loading}>
              {loading ? <span className="spinner" /> : '🎬 Get Verdict!'}
            </button>
            {error && <p className="error">{error}</p>}
          </form>
        ) : (
          <div className={`result ${VERDICT_CLASS[result.verdict] || ''}`}>
            <div className="verdict-emoji">{VERDICT_EMOJI[result.verdict] || '🎬'}</div>
            <div className="verdict-text">{result.verdict}</div>
            <div className="score-ring">
              <svg viewBox="0 0 120 120">
                <circle cx="60" cy="60" r="52" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="8" />
                <circle cx="60" cy="60" r="52" fill="none" stroke="currentColor" strokeWidth="8"
                  strokeDasharray="326.7" strokeDashoffset={326.7 - (result.score / 10) * 326.7}
                  strokeLinecap="round" transform="rotate(-90 60 60)" className="score-arc" />
              </svg>
              <span className="score-num">{result.score}/10</span>
            </div>
            <p className="explanation">{result.explanation || ''}</p>
            <div className="breakdown">
              <div className="breakdown-row">
                <span className="breakdown-label">🎭 Actor</span>
                <div className="breakdown-bar"><div className="breakdown-fill" style={{width: `${(result.actor_score||0)*10}%`}} /></div>
                <span className="breakdown-score">{result.actor_score}/10</span>
              </div>
              <p className="breakdown-reason">{result.actor_reason}</p>
              <div className="breakdown-row">
                <span className="breakdown-label">📖 Plot</span>
                <div className="breakdown-bar"><div className="breakdown-fill" style={{width: `${(result.plot_score||0)*10}%`}} /></div>
                <span className="breakdown-score">{result.plot_score}/10</span>
              </div>
              <p className="breakdown-reason">{result.plot_reason}</p>
              <div className="breakdown-row">
                <span className="breakdown-label">🎬 Scene</span>
                <div className="breakdown-bar"><div className="breakdown-fill" style={{width: `${(result.scene_score||0)*10}%`}} /></div>
                <span className="breakdown-score">{result.scene_score}/10</span>
              </div>
              <p className="breakdown-reason">{result.scene_reason}</p>
            </div>
            <div className="result-details">
              <span>🎭 {form.actor}</span><span>📖 {form.plot}</span>
              <span>🎬 {form.scene}</span><span>🎥 {form.movie}</span>
            </div>
            <button className="btn" onClick={reset}>🎬 Try Another!</button>
            {!showReview ? (
              <button className="btn challenge-btn" onClick={() => setShowReview(true)}>🙋 Challenge the Verdict!</button>
            ) : (
              <div className="review-box">
                <textarea placeholder="Tell us what's wrong... e.g. 'Dimple Kapadia plays the mother in this movie'" value={review} onChange={e => setReview(e.target.value)} />
                <button className="btn" onClick={challenge} disabled={loading}>
                  {loading ? <span className="spinner" /> : '📢 Submit Review'}
                </button>
              </div>
            )}
            {error && <p className="error">{error}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
